import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { HEADERS } from 'src/app/constants/services-headers';

@Injectable({
  providedIn: 'root'
})
export class ConsultancyService {

  constructor(private http: HttpClient) { }

  /* request(): Método común que solicita información al api de indicadores de red de acuerdo a los parámetros recibidos
    data: Parámetros recibidos desde cada componente
    nameMethod: Método que se ejecutará en el controlador del api
  */
  request = (data: FormData, nameMethod: string): Observable<any> => this.http.post(environment.apiPath + "ApiConsultancy/" + nameMethod, data, HEADERS);

  // getConsultancyReport() llama la API de consultoría para la información de los indicadores
  getConsultancyReport = (data: FormData, nameMethod: string): Observable<any> => this.request(data, nameMethod);

}
